// Import Packages
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import { Checkboxes } from "../../../FlowConfigurationInputs";
import { RadioOption, RadioPicker } from "../../../FlowConfigurationInputs/RadioPicker/RadioPicker";

// Import Recoil
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from "../../../../helpers/helper";

export default function Zip({
    action,
    variables,
    setOpenVariable,
    automId
}) {
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

    // const [value, setValue] = useState(action.fields.filetab?.value ? action.fields.filetab.value : 'file');
    const [destination, setDestination] = useState(action.fields.destinationFolder?.value ? action.fields.destinationFolder.value : 'samePath');

    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.FOLDER.";

    const options = {
        checkboxes: { label: label + "OVERWRITE" },
    };


    const handleChange = (e) => {
        let v = e.target.value;
        action.fields.destinationFolder = { value: v };
        if (v === 'givenPath') {
            if (action.fields.zipToPath) {
                action.fields.zipToPath.isRequired = true;
            } else {
                action.fields.zipToPath = { value: '', isRequired: false };
            }
            // delete action.fields.filePath.isRequired;
        } else {
            if (action.fields.zipToPath) {
                action.fields.zipToPath.isRequired = false;
            }
        }

        const field = initialActionsData[action.id]?.fields.destinationFolder;
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated('destinationFolder', action, oldValue, v, setSaveAvailable, setChangeFields, changedFieldsState);

        setDestination(v);
    };


    return (<div>
        <div className="conf-field-container">
            <FieldLabel name={t(label + "FOLDER-PATH")} is_required />
            <TextInput
                action={action}
                inputName="folderPath"
                variables={variables}
                setOpenVariable={setOpenVariable}
                isRequired
                // extractPath="folder"
                fieldType="string"
                displayName={t(label + 'FOLDER-PATH')}
                hideRequired
                autom_id={automId}
            />
        </div>

        <div className="conf-field-container">
            <FieldLabel name={t(label + "ZIP-NAME")} />
            <TextInput
                action={action}
                inputName="folderName"
                variables={variables}
                setOpenVariable={setOpenVariable}
                // extractPath="folder"
                fieldType="string"
                displayName={t(label + 'ZIP-NAME')}
            />
            <small className="conf-field-desc"><em>{t(label + 'ZIP-NAME-DESC')}</em></small>
        </div>
        <div className="conf-field-container">
            <FieldLabel classes={"radio-option-same-path"} name={t(label + "DESTINATION")} />
            <div style={{ marginTop: "20px" }}>
                <RadioPicker value={destination} onChange={handleChange}>
                    <RadioOption value="samePath" classes={"simple-radio-button"}>

                        <FieldLabel name={t(label + "ZIP.EXTRACT-SAME-PATH")} />
                    </RadioOption>
                    <RadioOption value="givenPath" active={destination === 'givenPath'}>
                        <div className="conf-field-container">
                            <FieldLabel name={t(label + "ZIP.EXTRACT-GIVEN-PATH")} is_required={destination === 'givenPath'} />
                            <TextInput
                                action={action}
                                inputName="zipToPath"
                                variables={variables}
                                setOpenVariable={setOpenVariable}
                                isRequired={destination === 'givenPath'}
                                fieldType="string"
                                displayName={t(label + 'ZIP.EXTRACT-GIVEN-PATH')}
                                autom_id={automId}
                                mateDrivePath="folderPath"
                                hideRequired
                            />
                        </div>
                    </RadioOption>
                    {/* <div className="conf-field-container">
                <FieldLabel name={t(label + 'ASSIGN')} is_required />
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired hideRequired />
                <small
                    className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
            </div> */}
                </RadioPicker>
            </div>
        </div>
        <div className="conf-field-container">
            <Checkboxes
                action={action}
                inputName="overwriteFolder"
                options={options.checkboxes}
            />
        </div>
        <div className="conf-field-container">
            <FieldLabel name={t(label + 'ZIP.ASSIGN')} />
            <VariablePicker action={action} inputName="set" variables={variables}
                setOpenVariable={setOpenVariable} filter="string" />
            <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'string' })}</em></small>
        </div>
    </div>
    );
}